export default {
  CONSTRUCT() {
    return {
      visible: false,
      items: ['APIs']
    };
  },
  TOGGLE_NAV(state) {
    return state.set('visible', !state.get('visible'));
  },
  HIDE_NAV(state) {
    return state.set('visible', false);
  }
};
